import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1694.232,1694.064 L1355.352,1694.064 L1355.352,1500.024 L1129.392,1500.024 L1129.392,1694.064 L790.632,1694.064 L790.632,1500.024 L564.672,1500.024 L564.672,1694.064 L225.912,1694.064 L225.912,225.984 L564.672,225.984 L564.672,425.784 L790.632,425.784 L790.632,225.984 L1129.392,225.984 L1129.392,425.784 L1355.352,425.784 L1355.352,225.984 L1694.232,225.984 L1694.232,1694.064 Z M1694.112,0.024 L225.912,0.024 C101.352,0.024 0.072,101.304 0.072,225.984 L0.072,1694.064 C0.072,1818.744 101.352,1920.024 225.912,1920.024 L1694.112,1920.024 C1818.672,1920.024 1920.072,1818.744 1920.072,1694.064 L1920.072,225.984 C1920.072,101.304 1818.672,0.024 1694.112,0.024 L1694.112,0.024 Z M1201.344,484.92 L960.024,726.24 L718.824,484.92 L484.944,718.68 L726.264,960 L484.944,1201.32 L718.824,1435.08 L960.024,1193.76 L1201.344,1435.08 L1434.984,1201.32 L1193.784,960 L1434.984,718.68 L1201.344,484.92 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTableDeleteColumnSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTableDeleteColumnSolid, _Component);

  var _super = _createSuper(IconTableDeleteColumnSolid);

  function IconTableDeleteColumnSolid() {
    _classCallCheck(this, IconTableDeleteColumnSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTableDeleteColumnSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTableDeleteColumn",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTableDeleteColumnSolid.displayName = "IconTableDeleteColumnSolid";
  return IconTableDeleteColumnSolid;
}(Component);

IconTableDeleteColumnSolid.glyphName = 'table-delete-column';
IconTableDeleteColumnSolid.variant = 'Solid';
IconTableDeleteColumnSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTableDeleteColumnSolid;
export { IconTableDeleteColumnSolid };